import { render, staticRenderFns } from "./NotificationsItem.vue?vue&type=template&id=58345622"
import script from "./NotificationsItem.vue?vue&type=script&lang=js"
export * from "./NotificationsItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsItem.vue?vue&type=style&index=0&id=58345622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports